import {
  EnvironmentInjector,
  inject,
  NgModule,
  runInInjectionContext
} from "@angular/core";
import {
  Integration,
  IntegrationAuthenticationType
} from "src/app/backend/models/integration";
import { CONNECT_INTEGRATION_CONNECTOR_TOKEN_FN } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connect-integration-connector.token";
import { ConnectIntegrationFunctionService } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connect-integration-function.service";
import { ConnectIntegrationConnector } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connect-integration.connector";
import { ConnectIntegrationBasicConnector } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connectors/connect-integration-basic.connector";
import { ConnectIntegrationCustomConnector } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connectors/connect-integration-custom.connector";
import { ConnectIntegrationNoneConnector } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connectors/connect-integration-none.connector";
import { ConnectIntegrationOAuthConnector } from "src/app/modules/bootstrap/functions/integrations/connect-integration/connectors/connect-integration-oauth.connector";

@NgModule({
  imports: [],
  declarations: [],
  providers: [
    ConnectIntegrationFunctionService,
    ConnectIntegrationOAuthConnector,
    ConnectIntegrationBasicConnector,
    ConnectIntegrationCustomConnector,
    ConnectIntegrationNoneConnector,
    {
      provide: CONNECT_INTEGRATION_CONNECTOR_TOKEN_FN,
      useFactory: () => {
        const injector = inject(EnvironmentInjector);

        return (integration: Integration) => {
          return runInInjectionContext<ConnectIntegrationConnector>(
            injector,
            () => {
              switch (integration.authentication.type) {
                case IntegrationAuthenticationType.BASIC: {
                  return inject(ConnectIntegrationBasicConnector);
                }
                case IntegrationAuthenticationType.OAUTH2: {
                  return inject(ConnectIntegrationOAuthConnector);
                }
                case IntegrationAuthenticationType.CUSTOM: {
                  return inject(ConnectIntegrationCustomConnector);
                }
                case IntegrationAuthenticationType.NONE: {
                  return inject(ConnectIntegrationNoneConnector);
                }
              }
            }
          );
        };
      }
    }
  ]
})
export class ConnectIntegrationFunctionModule {}
